import * as THREE from 'three';
// import { result } from 'underscore';
import Object2D from './core/Object2D';
import GeometoryBuilder from './core/GeometoryBuilder';
import { Line2 } from './math/Line2';
import { Line } from './objects/Line';
import { Square } from './objects/Square';
import { ClosePath } from './objects/ClosePath';

// import { vdb } from '../vdb/vdb.js';

export default class Scene {
    type: string;

    objects: Object2D[];

    geometoryBuilder: GeometoryBuilder;

    constructor() {
      this.type = 'Scene';
      this.objects = [];

      this.geometoryBuilder = new GeometoryBuilder();
    }

    public add(object: Object2D): this {
      if (object.isObject2D == false) {
        return this;
      }

      this.objects.push(object);

      this.construction(object);
      return this;
    }

    public box() {
      const min = new THREE.Vector2(+Infinity, +Infinity);
      const max = new THREE.Vector2(-Infinity, -Infinity);

      for (let i = 0; i < this.objects.length; i++) {
        const object = this.objects[i];
        if (object.type == 'Line') {
          min.min((object as Line).p1);
          max.max((object as Line).p1);
          min.min((object as Line).p2);
          min.max((object as Line).p2);
        }
        if (object.type == 'Square') {
          const { position } = object as Square;
          for (let i = 0; i < position.length; i++) {
            const p = position[i];

            min.min(p);
            max.max(p);
          }
        }
        if (object.type == 'ClosePath') {
          const { position } = object as ClosePath;
          for (let i = 0; i < position.length; i++) {
            const p = position[i];

            min.min(p);
            max.max(p);
          }
        }
      }
      return new THREE.Box2(min, max);
    }

    public convertPoints(ref: THREE.Vector2) {
      const result:THREE.Vector2[][] = [];

      for (let i = 0; i < this.objects.length; i++) {
        const object = this.objects[i];
        if (object.type == 'Line') {
          result.push([(object as Line).p1.clone().sub(ref),
            (object as Line).p2.clone().sub(ref)]);
        }
        if (object.type == 'Square') {
          const result_:THREE.Vector2[] = [];
          const { position } = object as Square;
          for (let i = 0; i < position.length; i++) {
            const p = position[i];

            result_.push(p.clone().sub(ref));
          }
          result.push(result_);
        }
        if (object.type == 'ClosePath') {
          const { position } = object as ClosePath;
          const result_:THREE.Vector2[] = [];

          for (let i = 0; i < position.length; i++) {
            const p = position[i];

            result_.push(p.clone().sub(ref));
          }
          result.push(result_);
        }
      }
      return result;
    }

    private construction(object: Object2D) {
      if (object.type == 'Line') {
        this.geometoryBuilder.addLine(new Line2((object as Line).p1, (object as Line).p2));
      }
      if (object.type == 'Square') {
        const { position } = object as Square;

        for (let i = 1; i <= position.length; i++) {
          const p1 = position[i - 1];
          const p2 = position[i % position.length];
          this.geometoryBuilder.addLine(new Line2(p1, p2));
        }
      }
      if (object.type == 'ClosePath') {
        const { position } = object as ClosePath;

        const n = 10;

        for (let i = 0; i < position.length; i++) {
          const p1 = position[i];
          const p2 = position[(i + 1) % position.length];
          this.geometoryBuilder.addLine(new Line2(p1, p2));

        //   if (i <= n) {
        //     vdb.line(p1.x, 0, p1.y, p2.x, 0, p2.y);
        //   }
        }
      }
    }
}
